<template>
  <b-modal
    :id="id"
    hide-header-close
    no-close-on-backdrop
    no-close-on-keyboard
    no-close-on-esc
    hide-footer
    :modal-class="modalClass"
  >
    <!-- HEADER -->
    <template #modal-header>
      <div class="w-100 d-flex align-items-center modal-header-custom">

        <!-- Back / Close -->
        <i style="font-size: 16px !important;"
          class="fas fa-chevron-left back-icon"
          @click="$emit('close')"
        ></i>

        <!-- Parent Page -->
        <span class="parent-text">
          {{ parent }}
        </span>

        <span class="separator">›</span>

        <!-- Current Page -->
        <span class="current-text">
          <i style="font-size: 16px !important;" :class="icon" class="current-icon"></i>
          {{ title }}
        </span>

        <!-- Institute Branding -->
        <div v-if="showInstituteBranding && institute.name" class="ml-auto d-flex align-items-center institute-branding">
          <img
            v-if="institute.logo"
            :src="cloudStorageRoot + institute.logo.file_path + institute.logo.file_name"
            class="institute-logo"
            alt="Institution Logo"
          />
          <span class="institute-name">{{ institute.name }}</span>
        </div>

      </div>
    </template>

    <!-- BODY -->
    <slot />
  </b-modal>
</template>

<script>
export default {
  name: "DashboardModal",
  props: {
    id: { type: String, required: true },

    /* Current page */
    title: { type: String, required: true },
    icon: { type: String, required: true },

    /* Parent page */
    parent: { type: String, required: true },

    modalClass: { type: String, default: "usersListPendingFull" },

    /* Off by default - this component is shared well beyond fee
       management, so other callers keep their existing header unchanged. */
    showInstituteBranding: { type: Boolean, default: false }
  },
  data() {
    return {
      cloudStorageRoot: null,
    };
  },
  computed: {
    institute() {
      return this.$store.getters.getCurrentInstitution || {};
    },
  },
  created() {
    this.cloudStorageRoot = this.$store.getters.getAPIKey.userAttachments;
  },
}
</script>

<style scoped>
.modal-header-custom {
  font-size: 14px;
  font-weight: 600;
}

.back-icon {
  cursor: pointer;
  margin-right: 10px;
  color: #0d6efd;
}

.back-icon:hover {
  opacity: 0.7;
}

.parent-text {
  color: #0d6efd;
}

.separator {
  margin: 0 8px;
  color: #6c757d;
}

.current-text {
  color: #212529;
  display: flex;
  align-items: center;
}

.current-icon {
  margin-right: 6px;
  font-size: 14px;
}

.institute-branding {
  gap: 8px;
}

.institute-logo {
  height: 28px;
  width: 28px;
  object-fit: contain;
  border-radius: 4px;
}

.institute-name {
  font-weight: 600;
  color: #212529;
}
</style>
